module.exports = __webpack_public_path__ + "img/icon_police_02.8c39e2d0.png";